import React from 'react'
import { Toaster as Sonner, type ToastClassnames } from 'sonner'

type SonnerToasterProps = React.ComponentProps<typeof Sonner>

type SonnerToastOptions = NonNullable<SonnerToasterProps['toastOptions']>

type SupportedToastOptions = Omit<
  SonnerToastOptions,
  'classNames'
> & {
  classNames?: Partial<ToastClassnames>
}

type ToasterProps = Omit<SonnerToasterProps, 'richColors' | 'toastOptions'> & {
  toastOptions?: SupportedToastOptions
}

function mergeClassName(base?: string, override?: string) {
  return [base, override].filter(Boolean).join(' ') || undefined
}

const Toaster = ({ className, toastOptions, ...props }: ToasterProps) => {
  const baseToastOptions = {
    classNames: {
      toast:
        'group toast rounded-lg !border-border/70 !bg-background !text-foreground !shadow-[var(--shadow-2)]',
      title: 'group-[.toast]:!text-foreground',
      description: 'group-[.toast]:!text-muted-foreground',
      actionButton: 'group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground',
      cancelButton: 'group-[.toast]:!bg-muted group-[.toast]:!text-muted-foreground',
    },
  }

  const callerClassNames = toastOptions?.classNames
  const mergedClassNames = {
    ...callerClassNames,
    toast: mergeClassName(baseToastOptions.classNames.toast, callerClassNames?.toast),
    title: mergeClassName(baseToastOptions.classNames.title, callerClassNames?.title),
    description: mergeClassName(baseToastOptions.classNames.description, callerClassNames?.description),
    actionButton: mergeClassName(baseToastOptions.classNames.actionButton, callerClassNames?.actionButton),
    cancelButton: mergeClassName(baseToastOptions.classNames.cancelButton, callerClassNames?.cancelButton),
  }

  const mergedToastOptions = {
    ...toastOptions,
    classNames: mergedClassNames,
  }

  return (
    <Sonner
      {...props}
      className={['toaster group', className].filter(Boolean).join(' ')}
      toastOptions={mergedToastOptions}
      richColors={false}
    />
  )
}

export { Toaster }
